import { Popup, ToolbarItem } from "devextreme-react/popup";
import notify from "../../lib/notify";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "../../lib/axios";

type DisableUserAccountLockPopupProps = {
  email: string;
  onClose: (accountUnlocked: boolean) => void;
};

export default function DisableUserAccountLockPopup({
  email,
  onClose,
}: DisableUserAccountLockPopupProps) {
  const { t } = useTranslation();
  const [disabled, setDisabled] = useState(false);

  const handleSubmit = useCallback(async () => {
    setDisabled(true);

    try {
      await axios.post("/api/auth/disable-account-locks", {
        email,
      });

      onClose(true);
    } catch (error) {
      notify(
        "Wystąpił błąd podczas próby odblokowania konta użytkownika.",
        "error"
      );
    } finally {
      setDisabled(false);
    }
  }, [email, onClose]);

  return (
    <Popup
      visible
      title={t("confirmationRequired")}
      onHiding={() => onClose(false)}
      maxWidth={500}
      height="auto"
      maxHeight="80vh"
      disabled={disabled}
      showCloseButton
      dragEnabled
    >
      <p>{t("disableUserAccountLockPopup.message")}</p>
      <ToolbarItem
        location="after"
        toolbar="bottom"
        widget="dxButton"
        options={{
          type: "danger",
          stylingMode: "contained",
          text: t("no"),
          onClick: () => onClose(false),
          disabled,
        }}
      />
      <ToolbarItem
        location="after"
        toolbar="bottom"
        widget="dxButton"
        options={{
          type: "default",
          stylingMode: "contained",
          text: t("yes"),
          onClick: handleSubmit,
          disabled,
        }}
      />
    </Popup>
  );
}
